<template>
    <v-container fluid>
    <tracking-skeleton :saving="saving" @save="save" @copyOpen="copyOpen" @mailOpen="mailOpen" v-model="open"  :fails.sync="fails" :platform="platform" :platformSettings="platformSettings">
        <!--
        <template v-slot:platformSettings>
            General settings
        </template>
        -->
        <template v-slot:tracker>
            <div id="instructions-tracker">
                <p>{{$t('tracking.shopify.instructions') }}</p>
                <v-btn color="success" :loading="trackingLoading" @click="enableTracking"><v-icon left>$trackingCode</v-icon>{{ $t('tracking.shopify.install') }}</v-btn>
            </div>
        </template>
    </tracking-skeleton>
    </v-container>
</template>
<script>

import TrackingSkeleton from '@/components/TrackingSkeleton'
import EntityForm from '@/mixins/entity-form'
import Wizards from '@/mixins/wizards'
import PanelOpener from "@/mixins/panel-opener"

export default {
    name: 'TrackingShopify',
    components: { TrackingSkeleton },
    mixins: [EntityForm, Wizards, PanelOpener ],
    data() {
        return {
            endpoint: 'domains',
            fields: {
            },
            panels: ['tracker'],
            platform: 'SHOPIFY',
            // this is here to allow copy to clipboard
            code: {
                tracker: `NO CODE TO COPY`
            },
            trackingLoading: false
        }
    },
    computed: {
        platformSettings() {
            return this.$store.getters['domains/platformSettings'](this.platform)
        }
    },
    methods: {
        async enableTracking() {
            this.trackingLoading = true;
            let result = await this.$store.dispatch('domains/shopifyCreateTags', { id: this.item.id, store: this.item.productFeedURL })
            this.trackingLoading = false;
            let msg;
            if(result) {
                msg = { text: this.$t('tracking.shopify.success') }
            } else {
                msg = { text: this.$t('tracking.shopify.fail'), error: true }
            }
            this.$store.dispatch('ui/notify', msg);
        }
    }
}
</script>